import { FillType } from '~/static/enums/components/color-input'
import { ObjectType } from '~/static/enums/object-type'
import { Icon } from '~/static/icons'
import { VersionMigrator } from '~/utils/editor/versioning/migrators'
import { ObjectPropsV1, ObjectPropsV2, migrate as migrateObject } from '~/utils/editor/versioning/object'

export enum Versions {
  V1 = 1, // data has no field 'version'
  V2 = 2,
}

export const ActualVersionNumber = Versions.V2
export type ActualVersion = IconPropsV2

export interface IconPropsV1 extends ObjectPropsV1 {
  type?: ObjectType.Icon

  svg?: Icon
  width?: number
  height?: number
  colorType?: FillType
  color?: FabricGradientOptions | string
  opacity?: number
  shadow?: boolean
  shadowColor?: string
  shadowOpacity?: number
  shadowX?: number
  shadowY?: number
  shadowBlur?: number
  isColored?: boolean
}

export interface IconPropsV2 extends ObjectPropsV2 {
  type?: ObjectType.Icon

  svg?: Icon
  width?: number
  height?: number
  colorType?: FillType
  color?: FabricGradientOptions | string
  opacity?: number
  shadow?: boolean
  shadowColor?: string
  shadowOpacity?: number
  shadowX?: number
  shadowY?: number
  shadowBlur?: number
  isColored?: boolean
}

export const migrate: VersionMigrator<IconPropsV2> = (data: object) => {
  if ('version' in data && data.version === Versions.V2) {
    return data as IconPropsV2
  }

  const dataV1 = data as IconPropsV1

  return {
    type: ObjectType.Icon,  
    ...migrateObject(dataV1),
    version: Versions.V2,
    title: dataV1.svg?.title,
    svg: dataV1.svg,
    width: dataV1.width,
    height: dataV1.height,
    colorType: dataV1.colorType,
    color: dataV1.color,
    opacity: dataV1.opacity,
    shadow: dataV1.shadow,
    shadowColor: dataV1.shadowColor,
    shadowOpacity: dataV1.shadowOpacity,
    shadowX: dataV1.shadowX,
    shadowY: dataV1.shadowY,
    shadowBlur: dataV1.shadowBlur,
    isColored: dataV1.isColored,
  } as IconPropsV2
}
